import { useNavigation } from '@refinedev/core';

import { useSnackbar } from '@rrexpress/core';

import { BaseCreate } from '@/components/create';
import useBranch from '@/modules/branch/application/branch';

import BranchForm from './form';

const BranchCreate = () => {
  const { list } = useNavigation();
  const { createBranch, loadingCreate } = useBranch();
  const { show } = useSnackbar();

  async function handleOnSubmit(val: any) {
    try {
      await createBranch(val);
      list('branches');
      show('Berhasil membuat cabang', 'success');
    } catch (error) {
      show('Gagal membuat cabang', 'error');
    }
  }
  return (
    <div className="w-[50vw] flex m-auto justify-center">
      <BaseCreate
        title="Tambah Cabang"
        isLoading={loadingCreate}
      >
        <BranchForm
          onFinish={handleOnSubmit}
          type="create"
          initialValue={{}}
        />
      </BaseCreate>
    </div>
  );
};

export default BranchCreate;
